/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_Preview_Col_MaxInputs */

const da_forside_preview_col_max = /** @type {(inputs: Forside_Preview_Col_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maks`)
};

/** @type {(inputs: Forside_Preview_Col_MaxInputs) => LocalizedString} */
const en_forside_preview_col_max = da_forside_preview_col_max;

/**

* @param {Forside_Preview_Col_MaxInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_preview_col_max = /** @type {((inputs?: Forside_Preview_Col_MaxInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Preview_Col_MaxInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_preview_col_max(inputs)
	return /** @type {LocalizedString} */ ("Maks")
});